import { useEffect, useRef, useState } from 'react'
import './IntroScreen.css'

interface IntroScreenProps {
  onDone: () => void
  onUnmount: () => void
  showLogo: boolean
  onSplashReady?: (continueAnimation: () => void) => void
  duration?: number
}

export function IntroScreen({ onDone, onUnmount, showLogo, onSplashReady }: IntroScreenProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const logoRef = useRef<HTMLImageElement>(null)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (!showLogo) return

    const el = containerRef.current
    if (!el) return

    // [0ms]     splash opacity:1 (czarne tło), logo opacity:0
    // [200ms]   logo fade-in 900ms
    // [1100ms]  logo pełne — STOP i czekaj na auth
    //           onSplashReady(continueAnimation) — App.tsx decyduje kiedy kontynuować
    // po continueAnimation():
    //   [+250ms]  start fade-out splasha 1200ms
    //   [+1450ms] E1 odsłonięty, unmount splasha

    const t1 = setTimeout(() => {
      logoRef.current?.classList.add('logo-fadein')     // logo fade-in 900ms
    }, 200)

    const t2 = setTimeout(() => {
      onDone()                                          // E1 montuje się pod czarnym tłem
      if (onSplashReady) {
        // Powiadom App.tsx — splash czeka na sygnał do kontynuacji
        onSplashReady(() => {
          if (!el) return
          setTimeout(() => {
            el.classList.add('splash-fadeout')          // splash fade-out 1200ms
          }, 250)
          setTimeout(() => { setVisible(false); onUnmount() }, 1700)
        })
      } else {
        // Brak onSplashReady — stare zachowanie (natychmiastowe dokończenie)
        setTimeout(() => { el.classList.add('splash-fadeout') }, 250)
        setTimeout(() => { setVisible(false); onUnmount() }, 1700)
      }
    }, 1100)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    }
  }, [showLogo, onDone, onSplashReady])

  if (!visible) return null

  return (
    <div ref={containerRef} className="intro-splash">
      <img ref={logoRef} src="/logo.png" className="intro-logo" alt="logo" />
    </div>
  )
}
